import { Badge } from '@thefarmersfront/kitchen';

import type { ColDef, ICellRendererParams, IRowNode, ValueFormatterParams } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';

import { formatDate, formatNumber } from '~/utils';

import { DATE_FORMAT, STOCK_RELEASE_REQUEST_STATUS } from '~/constants';

import type { TypeStockReleaseInfo } from '~/types/stock.types';

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 조회 테이블
 */
const getStockReleaseColumnDefs = ({ onClickViewDetail }: { onClickViewDetail: (id: number) => void }) => {
  const columnDefs: ColDef<TypeStockReleaseInfo>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 72,
    },
    {
      field: 'id',
      headerName: '반출요청번호',
      width: 180,
    },
    {
      field: 'statusCode',
      headerName: '반출 상태',
      width: 100,
      minWidth: 100,
      cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'start' },
      cellRenderer: Badge,
      cellRendererParams: ({
        value,
      }: ICellRendererParams<TypeStockReleaseInfo, TypeStockReleaseInfo['statusCode']>) => ({
        variant: 'light',
        status: true,
        color: STOCK_RELEASE_REQUEST_STATUS[value as keyof typeof STOCK_RELEASE_REQUEST_STATUS]?.color,
        children: STOCK_RELEASE_REQUEST_STATUS[value as keyof typeof STOCK_RELEASE_REQUEST_STATUS]?.text,
      }),
    },
    {
      field: 'clusterCodeObject.name',
      headerName: '반출 출발지 센터',
      width: 120,
    },
    {
      field: 'methodCodeObject.name',
      headerName: '반출 방식',
      width: 80,
    },
    {
      field: 'expectedDate',
      headerName: '반출 희망일',
      width: 100,
      valueFormatter: ({ value }: ValueFormatterParams<TypeStockReleaseInfo, TypeStockReleaseInfo['expectedDate']>) =>
        formatDate(value, DATE_FORMAT.DATE) ?? '-',
    },
    {
      field: 'skuCount',
      headerName: 'SKU 수',
      width: 80,
      valueFormatter: ({ value }: ValueFormatterParams<TypeStockReleaseInfo, TypeStockReleaseInfo['skuCount']>) =>
        value ? formatNumber(value) : '-',
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'totalRequestQuantity',
      headerName: '총 수량',
      width: 80,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseInfo, TypeStockReleaseInfo['totalRequestQuantity']>) =>
        value ? formatNumber(value) : '-',
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'createdAt',
      headerName: '요청등록일시',
      width: 160,
      valueFormatter: ({ value }: ValueFormatterParams<TypeStockReleaseInfo, TypeStockReleaseInfo['createdAt']>) =>
        formatDate(value, DATE_FORMAT.DATE_TIME) ?? '-',
    },
    {
      headerName: '',
      minWidth: 80,
      width: 80,
      cellRenderer: TextButtonCell,
      cellRendererParams: {
        children: '상세보기',
        showDashIfNoValue: false,
        onClick: ({ data }: IRowNode<TypeStockReleaseInfo>) => {
          data?.id && onClickViewDetail(data?.id);
        },
      },
      flex: 1,
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
  ];

  return { columnDefs };
};

export default getStockReleaseColumnDefs;
